<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col mt-4 mb-3">
        <div class="card">
          <div class="card-header p-3 pt-2 pb-0">
            <div
              class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 me-3 float-start"
            >
              <i class="material-icons opacity-10">filter_alt</i>
            </div>
            <h5>Senceive Time Log Processing</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-2">
                <div v-if="oidcIsAuthenticated">
                  Authenticated as {{ userFullName }}<br>
                </div>
                <div v-else>
                  <p class="card-text">Not currently logged in</p>
                  <material-button color="primary" :disabled="authenticating" @click="loginClicked">Log In To Wrike</material-button>
                </div>
              </div>
              <div class="col-2">
                Start Date:
                <material-input v-model:value="startDatePicker" type="date" placeholder="Start Date" />
              </div>
              <div class="col-2">
                End Date:
                <material-input v-model:value="endDatePicker" type="date" placeholder="End Date" />
              </div>
              <div class="col-3">
                <div class="row">
                  <div class="col">
                    <material-button class="w-100 h-100" color="primary" :disabled="!oidcIsAuthenticated || loadingData" @click="loadClicked">Load Data</material-button>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <material-button class="w-100 h-100" color="secondary" :disabled="loadingData || timelogCount === 0" @click="downloadClicked">Download XLSX</material-button>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div v-if="loadingData">
                  <h6>Loading...</h6>
                  Folders: {{ folderCount }}, Tasks: {{ taskCount }}, Timelog Entries: {{ timelogCount }}
                </div>
                <div v-else>
                  <h6>Timelog Entries:</h6>
                  Valid: {{ timelogCount }} Invalid: {{ badTimelogCount }}
                </div>
                <material-switch id="showUserFilters" v-model:checked="showUserFilters" name="showUserFilters">
                  User Filters
                  <span v-if="userFiltersCheckedCount > 0">({{ userFiltersCheckedCount }})</span>
                </material-switch>
              </div>
            </div>
            <template v-if="oidcIsAuthenticated && showUserFilters">
              <div class="row">
                <div class="col-2">
                  <b>Groups</b>
                </div>
                <template v-for="group in displayGroups" :key="group.groupId">
                  <div class="col-2">
                    <material-checkbox :id="group.groupId" v-model:checked="group.checked" name="userFilter">{{group.name}}</material-checkbox>
                  </div>
                </template>
              </div>
              <div class="row">
                <div class="col-2">
                  <b>Users</b>
                </div>
                <template v-for="user in displayUsers" :key="user.userId">
                  <div class="col-2">
                    <material-checkbox :id="user.userId" v-model:checked="user.checked" name="userFilter">{{user.name}}</material-checkbox>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="badTimelogsFiltered.length > 0" class="row">
      <div class="col mt-4 mb-3">
        <div class="card">
          <div class="card-header p-3 pt-2 pb-0">
            <div
              class="icon icon-lg icon-shape bg-gradient-warning shadow-warning text-center border-radius-xl mt-n4 me-3 float-start"
            >
              <i class="material-icons opacity-10">error_outline</i>
            </div>
            <h5>Invalid Time Log Entries</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <DataTable
                class="display table table-bordered table-sm text-sm"
                :data="badTimelogsFiltered" :columns="badTimelogColumns" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="timelogCount > 0" class="row">
      <div class="col mt-4 mb-3">
        <div class="card">
          <div class="card-header p-3 pt-2 pb-0">
            <div class="icon icon-lg icon-shape bg-gradient-success shadow-success text-center border-radius-xl mt-n4 me-3 float-start">
              <i class="material-icons opacity-10">punch_clock</i>
            </div>
            <h5>Time Log Entries</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <DataTable
                class="display table table-bordered table-sm text-sm"
                :data="timelogsFiltered" :columns="timelogColumns"
                :options="{ lengthMenu: [ 10, 25, 50, 100, 1000, { label: 'All', value: -1 } ] }"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="timelogCount > 0" class="row">
      <div class="col mt-4 mb-3">
        <div class="card">
          <div class="card-header p-3 pt-2 pb-0">
            <div class="icon icon-lg icon-shape bg-gradient-success shadow-success text-center border-radius-xl mt-n4 me-3 float-start">
              <i class="material-icons opacity-10">calendar_month</i>
            </div>
            <h5>Coverage Check</h5>
          </div>
          <div class="card-body">
            <CoverageTable ref="coverageTable" :users="users" :timelogs="timelogs" :user-ids-filter="userIdsFilter" :start-date="startDate" :end-date="endDate"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="timelogCount > 0" class="row">
      <div class="col mt-4 mb-3">
        <div class="card">
          <div class="card-header p-3 pt-2 pb-0">
            <div class="icon icon-lg icon-shape bg-gradient-success shadow-success text-center border-radius-xl mt-n4 me-3 float-start">
              <i class="material-icons opacity-10">savings</i>
            </div>
            <h5>Account Totals</h5>
          </div>
          <div class="card-body">
            <AccountsTable ref="accountsTable" :users="users" :timelogs="timelogs" :user-ids-filter="userIdsFilter"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row"></div>
  </div>
</template>
<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';
import axios from 'axios';
import XLSX from "xlsx";
import CoverageTable from "./components/CoverageTable.vue";
import AccountsTable from "./components/AccountsTable.vue";
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
DataTable.use(DataTablesCore);


export default {
  name: "DashboardDefault",
  components: {
    MaterialInput,
    MaterialButton,
    MaterialCheckbox,
    MaterialSwitch,
    DataTable,
    CoverageTable,
    AccountsTable
  },
  data() {
    //Init start/end dates
    let now = new Date()
    if(now.getDate() < 8) {
      //in the first week of the month, so let's put 'now' in last month
      now.setMonth(now.getMonth() - 1)
    }

    const hoursFormatter = new Intl.NumberFormat(navigator.languages, {minimumFractionDigits: 2, maximumFractionDigits: 2})

    const sharedTimelogColumns = [
      {
        title: 'Date',
        data: 'trackedDate',
        render: dateToIsoString,
        type: 'string'
      },
      {
        title: 'User Name',
        data: 'userId',
        defaultContent: '(Unknown)',
        render: (data) => this.users.get(data)
      },
      {
        title: 'Task',
        data: '_task',
        defaultContent: '',
        render: (data) => data && `<a href="${data?.permalink}" target="_blank" rel="noopener noreferrer">${data?.title}</a>`
      },
      {
        title: 'Hours',
        data: 'hours',
        render: (data) => hoursFormatter.format(data),
        searchable: false
      }
    ]

    const defaultStartDate = new Date(now.getUTCFullYear(), now.getUTCMonth(), 1) // first day of month
    const defaultEndDate = new Date(now.getUTCFullYear(), now.getUTCMonth() + 1, 0) // last day of month
    return {
      authenticating: false,
      userFullName: '(loading...)',
      loadingData: false,
      startDatePicker: dateToIsoString(defaultStartDate),
      endDatePicker: dateToIsoString(defaultEndDate),
      startDate: defaultStartDate,
      endDate: defaultEndDate,
      displayGroups: new Array(),
      displayUsers: new Array(),
      showUserFilters: false,
      users: new Map(),
      groups: new Map(),
      folders: new Map(),
      timelogs: new Array(),
      badTimelogs: new Array(),
      tasks: new Map(),
      timelogColumns: [
        ...sharedTimelogColumns,
        {
          title: 'Account',
          data: '_task._account',
          defaultContent: ''
        },
        {
          title: 'Comment',
          data: 'comment'
        }
      ],
      badTimelogColumns: [
        ...sharedTimelogColumns,
        {
          title: 'Error',
          data: '_error'
        }
      ],
    };
  },
  computed: {
    ...mapGetters([
      'oidcIsAuthenticated',
      'oidcUser',
      'oidcAccessToken'
    ]),
    folderCount() {
      return this.folders.size
    },
    timelogCount() {
      return this.timelogs.length
    },
    badTimelogCount() {
      return this.badTimelogs.length
    },
    taskCount() {
      return this.tasks.size
    },
    userFiltersCheckedCount() {
      var checkedCount = 0
      checkedCount += this.displayUsers.filter((du) => du.checked).length
      checkedCount += this.displayGroups.filter((df) => df.checked).length
      return checkedCount
    },
    userIdsFilter() {
      const userIds = new Set()
      var anyChecked = false
      this.displayUsers.forEach((du) => {
        if (du.checked) {
          anyChecked = true
          userIds.add(du.userId)
        }
      })
      this.displayGroups.forEach((dg) => {
        if(dg.checked) {
          anyChecked = true
          dg.memberIds.forEach((u) => {
            userIds.add(u)
          })
        }
      })
      if(!anyChecked) {
        this.users.forEach((name, id) => userIds.add(id))
      }
      return userIds
    },
    timelogsFiltered() {
      return this.timelogs.filter((e) => this.userIdsFilter.has(e.userId))
    },
    badTimelogsFiltered() {
      return this.badTimelogs.filter((e) => this.userIdsFilter.has(e.userId))
    },
  },
  watch: {
    oidcAccessToken() {
      this.reloadUser()
      console.log('oidcAccessToken Changed')
    }
  },
  mounted() {
    this.reloadUser()
  },
  methods: {
    ...mapActions([
      'authenticateOidc'
    ]),
    async reloadUser() {
      if(!this.oidcIsAuthenticated) {
        return
      }
      const contacts = await wrikeApiGet('contacts')
      for (const c of contacts.data) {
        const name = c.firstName + ' ' + c.lastName
        if(c.me) {
          this.userFullName = name
        }
        if(c.type === 'Person') {
          this.users.set(c.id, name)
          const du = this.displayUsers.find((u) => u.userId === c.id)
          if(du === undefined) {
            this.displayUsers.push({ userId: c.id, name, checked: false })
          } else {
            du.name = name
          }
        }
        if(c.type === 'Group') {
          this.groups.set(c.id, { name: c.firstName, memberIds: c.memberIds })
          const dg = this.displayGroups.find((g) => g.groupId === c.id)
          if(dg === undefined) {
            this.displayGroups.push({ groupId: c.id, name: c.firstName, memberIds: c.memberIds, checked: false })
          } else {
            dg.name = c.firstName
            dg.memberIds = c.memberIds
          }
        }
      }
      sortByName(this.displayGroups)
      sortByName(this.displayUsers)
    },
    loginClicked() {
      this.authenticating = true
      this.authenticateOidc()
    },
    async loadClicked() {
      this.loadingData = true
      this.startDate = new Date(this.startDatePicker)
      this.endDate = new Date(this.endDatePicker)
      this.badTimelogs.length = 0
      const timelogsPromise = loadTimelogsAndTasks(this)
      const foldersPromise = loadFolders(this.folders)
      await timelogsPromise
      await foldersPromise

      for (const timelog of this.timelogs) {
        try {
          //Link Task to timelog entry
          if(this.tasks.has(timelog.taskId)) {
            timelog._task = this.tasks.get(timelog.taskId)
          } else {
            throw new Error('Task not found for this timelog entry')
          }

          //Determine the list of folder paths and accounts for this timelog entry
          if('_paths' in timelog._task === false) {
            const paths = new Set()
            const parentFolderIds = new Array(...timelog._task.parentIds, ...timelog._task.superParentIds)
            for (const folderId of parentFolderIds) {
              this.folders.get(folderId)?._paths.forEach((path) => {
                paths.add(path)
              })
              //paths.add(this.folders.get(folderId)?._paths)
            }
            paths.delete(undefined)

            if (paths.count == 0) {
              throw new Error('Task is not in the Team folder tree')
            }

            let account = undefined
            for (const path of paths.values()) {
              if (account === undefined || account > path.account) {
                account = path.account
              }
            }
            if (!account) {
              throw new Error('No matching account found')
            }
            
            timelog._task._paths = paths
            timelog._task._account = account
          }

        } catch(err) {
          timelog._error = err.message
        }
      }

      //Remove timelogs in error
      let i
      while ((i = this.timelogs.findIndex((t) => t._error)) !== -1) {
        this.badTimelogs.push(...this.timelogs.splice(i, 1))
      }

      this.loadingData = false
    },
    async downloadClicked() {
      const coverSheet = XLSX.utils.aoa_to_sheet([
        [ 'Senceive Time Log Processing' ],
        [],
        [ 'Exported:',    new Date().toString() ],
        [ 'From:',        window.location.href ],
        [ 'User:',        this.userFullName ],
        [ 'Start Date:',  dateToIsoString(this.startDate) ],
        [ 'End Date:',    dateToIsoString(this.endDate) ],
      ])
      const timelogsSheet = XLSX.utils.aoa_to_sheet(
      [
        [
          'Timelog Entry ID',
          'Task Title',
          'Task Paths',
          'User Name',
          'Hours',
          'Date',
          'Timelog Entry Comment',
          'Accounts',
          'Final Account'
        ],
        ...this.timelogs.map((t) => {
          let taskPaths = []
          let taskAccounts = []
          t._task._paths.forEach((p) => {
            taskPaths.push(p.path.join('/'))
            taskAccounts.push(p.account)
          })
          return [
            t.id,
            t._task.title,
            taskPaths.join('; '),
            this.users.get(t.userId) || '(Unknown)',
            t.hours,
            t.trackedDate,
            t.comment.replace('\n', ' '),
            taskAccounts.join('; '),
            t._task._account
          ]
        })
      ])

      const coverageSheet = XLSX.utils.aoa_to_sheet([
        [
          ...this.$refs.coverageTable.columns.map((d) => d.title)
        ],
        ...this.$refs.coverageTable.data.map((u) => [
          ...this.$refs.coverageTable.columns.map((d, index) => {
            if (index === 0) {
              return this.users.get(u.userId) || u.userId
            } else if (index === 1) {
              return u.total
            }
            return u[d.data.replaceAll('\\.', '.')]
          })
        ])
      ])

      const accountsSheet = XLSX.utils.aoa_to_sheet([
        [
          ...this.$refs.accountsTable.columns.map((a) => a.title)
        ],
        ...this.$refs.accountsTable.data.map((u) => [
          ...this.$refs.accountsTable.columns.map((a, index) => {
            if (index === 0) {
              return this.users.get(u.userId) || u.userId
            }
            return u[a.title]
          })
        ])
      ])

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, coverSheet, 'Cover Sheet')
      XLSX.utils.book_append_sheet(workbook, timelogsSheet, 'Timelogs')
      XLSX.utils.book_append_sheet(workbook, coverageSheet, 'Coverage')
      XLSX.utils.book_append_sheet(workbook, accountsSheet, 'Accounts')
      XLSX.writeFile(workbook, `Timelogs-${dateToIsoString(new Date())}.xlsx`, { compression: true })
    },
  },
};

function dateToIsoString(date) {
  let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
  let month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date)
  let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
  return `${year}-${month}-${day}`
}

async function wrikeApiGet(url, params={}) {
  //TODO get this value dynamically from the token endpoint response
  const API_BASE = "www.wrike.com"
  try {
    const requestConfig = {
      baseURL: `https://${API_BASE}/api/v4/`,
      headers: {
        "Authorization": "Bearer " + store.getters.oidcAccessToken
      },
      params
    }
    const response = await axios.get(url, requestConfig)
    return response.data
  } catch (error) {
    console.warn(error)
  }
}

async function getCustomField(fieldName) {
  const customFields = await wrikeApiGet('customfields')
  for (const cf of customFields.data) {
    if (cf.title == fieldName) {
      return cf
    }
  }
  throw new Error(`Custom field with title ${fieldName} not found`)
}

async function getFoldersFromSpace(spaceName, folders) {
  const spacesData = await wrikeApiGet('spaces')
  const space = spacesData.data.find((s) => s.title === spaceName)
  if (!space) {
    throw new Error(`Space with title ${spaceName} not found`)
  }

  //Get full list of folder, but we can't get the custom fields at the same time
  const foldersData = await wrikeApiGet(`spaces/${space.id}/folders`, {
    descendants: true
  })

  const folderIds = foldersData.data.map((f) => f.id)

  //Get the full folder records in batches
  const gets = []
  for(let i = 0; i < folderIds.length; i += 100) {
    const batchIds = folderIds.slice(i, i + 100)
    gets.push(getFolderBatch(folders, batchIds))
  }
  await Promise.all(gets)

  return folders.get(space.id)
}

async function getFolderBatch(folders, batchIds) {
  const resp = await wrikeApiGet('folders/' + batchIds.join(','))
  for (const f of resp.data) {
    folders.set(f.id, f)
  }
}

function buildFolderPaths(folders, folder, prefix=[], accountName) {
  const path = [...prefix, folder.title]
  const account = folder._accountName || accountName
  folder._paths ??= new Set()
  folder._paths.add({
    path,
    account
  })
  
  for (const c of folder.childIds) {
    if (folders.has(c)) {
      buildFolderPaths(folders, folders.get(c), path, account)
    }
  }
}

async function getTimelogs(timelogs, startDate, endDate) {
  /* Deliberately getting all timelogs visible to the user rather
  than just those within the designated Space.
  This helps deal with the situation where the user has logged time
  against a task which is not in the right Space. */
  const endDateAdj = new Date(endDate)
  endDateAdj.setDate(endDateAdj.getDate() + 1)
  const filters = {
    trackedDate: JSON.stringify({
      start: dateToIsoString(startDate),
      end: dateToIsoString(endDateAdj)
    })
  }
  const resp = await wrikeApiGet('timelogs', filters)
  timelogs.push(...resp.data.map((t) => ({
    ...t,
    trackedDate: new Date (t.trackedDate)
  })))
}

async function getTasks(tasks, taskIds) {
  const gets = []
  for(let i = 0; i < taskIds.length; i += 100) {
    const batchIds = taskIds.slice(i, i + 100)
    gets.push(getTaskBatch(tasks, batchIds))
  }
  await Promise.all(gets)
}

async function getTaskBatch(tasks, batchIds) {
  const resp = await wrikeApiGet('tasks/' + batchIds.join(','))
  for (const t of resp.data) {
    tasks.set(t.id, t)
  }
}

async function loadTimelogsAndTasks({startDate, endDate, timelogs, tasks}) {
  timelogs.length = 0
  tasks.clear()
  await getTimelogs(timelogs, startDate, endDate)
  await getTasks(tasks, timelogs.map((t) => t.taskId))
}

async function loadFolders(folders) {
  const _SPACE_NAME = 'Team'
  const _ACCOUNT_FIELD_NAME = 'Finance Account'

  const accountField = await getCustomField(_ACCOUNT_FIELD_NAME)

  folders.clear()
  const rootFolder = await getFoldersFromSpace(_SPACE_NAME, folders)

  // Extract the account name field in each folder for later
  for (const f of folders.values()) {
    if (f.customFields) {
      for (const cf of f.customFields.values()) {
        if (cf.id == accountField.id) {
          f._accountName = cf.value
        }
      }
    }
  }

  buildFolderPaths(folders, rootFolder)
}

function sortByName(array) {
  array.sort((a, b) => {
    if (a.name > b.name) {
      return 1
    } else if (a.name < b.name) {
      return -1
    } else {
      return 0
    }
  })
}

</script>
<style>
@import 'datatables.net-bs5';
</style>